module.exports = __webpack_public_path__ + "img/USERS_SETTING.73985ca5.svg";